import ExportedImage from 'next-image-export-optimizer';

import { motion } from 'framer-motion';

import AnimateWhileInView from '@/components/shared/AnimateWhileInView';
import CtaButton from '@/components/shared/lp/CtaButton';

import { siteData } from '@/data/site';
import swap from '@/public/images/lp/developer/swap.png';
import portfolioMangement from '@/public/images/lp/home/portfolio-management-1.png';
import protocolSupport from '@/public/images/lp/home/protocolSupport.png';
import gradientLinkArrow from '@/public/images/lp/svgs/gradient-link-arrow.svg';

const ProtocolSupport = () => {
  return (
    <section className='mx-auto my-10 flex items-center justify-between gap-x-[82px] text-white lg:my-24 lg:w-full 2xl:my-36 -lg:flex-col'>
      <div className='flex w-1/2 flex-col space-y-4 -lg:mb-12 -lg:w-[80%] -lg:items-center -lg:text-center -sm:w-auto'>
        <AnimateWhileInView delay={0.15}>
          <h3 className='font-heading font-semibold leading-[4rem] md:text-5xl -lg:text-4xl -sm:text-2xl'>
            We pioneered Atomic Swaps
          </h3>
        </AnimateWhileInView>
        <AnimateWhileInView delay={0.2}>
          <p className='text-xl leading-10 -lg:text-lg -sm:text-[14px] -sm:leading-[18px]'>
            Our atomic swaps empower users to trade assets securely across blockchains—without
            intermediaries. This breakthrough technology is the foundation of our DeFi ecosystem,
            ensuring trustless, transparent transactions for all.
          </p>
        </AnimateWhileInView>
        <AnimateWhileInView delay={0.25}>
          <motion.a
            target='_blank'
            href='https://komodoplatform.com/en/blog/atomic-swaps/'
            className='trustless-gradient flex h-14 flex-row items-center rounded-md text-xl font-bold leading-10 underline -lg:flex-col -lg:text-lg'
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            transition={{ type: 'spring', stiffness: 400, damping: 17 }}
          >
            Read more about{' '}
            <span className='ml-1 flex flex-row items-center'>
              Atomic Swaps
              <ExportedImage
                src={gradientLinkArrow}
                className='ml-2 h-[19px] w-auto'
                width={16}
                height={17}
                alt='link'
              />
            </span>
          </motion.a>
        </AnimateWhileInView>
      </div>
      <AnimateWhileInView delay={0.3} classNaming='w-full sm:w-[80%] lg:w-1/2 -lg:mx-auto'>
        <ExportedImage
          className='h-auto w-full lg:w-[450px] 2xl:w-[484px]'
          src={swap}
          alt='We pioneered Atomic Swaps'
        />
      </AnimateWhileInView>
    </section>
  );
};

export default ProtocolSupport;
